/**
 * Logout Page
 * Clears client-side auth and payment state, then redirects to /login.
 * Intended as a 3rd-party-friendly redirect target.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { usePaymentStore } from '@/store/paymentStore';
import { ROUTE_PATHS } from '@/utils/constants';

export default function LogoutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    useAuthStore.getState().logout();
    usePaymentStore.getState().clearPaymentData();
    navigate(ROUTE_PATHS.LOGIN, { replace: true });
  }, [navigate]);

  return null;
}
